import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAsp from 'hooks/useAsp';

// felmat CV計測タグ
// - サンクスページ（/cloudwifi/ec/complete）表示時のみ発火
// - fmcv.js は読み込まれた時点で即計測ビーコンを送信するため、isThanks のときだけ挿入する
// - uqid（発行タグの TIMESTAMP 部分）には注文番号を設定。felmat側は同一 uqid を
//   重複排除するため、タイムスタンプではなく注文番号を使うことで二重計測を防ぐ
const FelmatTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isThanks || !order) return;

    const orderCode = order.order_code ?? '';
    if (!orderCode) return;

    // 二重発火防止
    const firedKey = `felmat-fired-${orderCode}`;
    if (sessionStorage.getItem(firedKey)) return;
    sessionStorage.setItem(firedKey, '1');

    const scriptId = 'felmat-cv';
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.src = `https://js.felmat.net/fmcv.js?adid=N11090B&uqid=${encodeURIComponent(orderCode)}`;
    document.body.appendChild(script);

    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [pathname, isThanks, order]);

  return null;
};

export default FelmatTag;
